/**
 * Edit Review Status
 */
export enum EditReviewStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}
